export default __webpack_public_path__ + "AbbisWayIcons.16de920262b0c6be682f52ad928b33ce.ttf";